import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  VehicleHistory,
  VehicleHistoryDetail,
  VehicleHistoryDetailQuery,
  VehicleHistoryPortoRequest,
  VehicleHistoryPortoResponse,
  VehicleHistoryQuery,
} from './VehiclesHistory.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/VehicleHistory`;

export async function listVehiclesHistory(params: VehicleHistoryQuery) {
  const result = (await api.get(
    `${CONTROLLER_URL}/listVehicleHistory`,
    params,
  )) as unknown;

  return result as PageResult<VehicleHistory>;
}

export async function detailVehicleHistory(params?: VehicleHistoryDetailQuery) {
  const result = (await api.get(
    `${CONTROLLER_URL}/getlicenseplace`,
    params,
  )) as unknown;

  return result as VehicleHistoryDetail;
}

export async function vehicleHistoryPorto(params?: VehicleHistoryPortoRequest) {
  const result = (await api.get(`${CONTROLLER_URL}/porto`, params)) as unknown;

  return result as VehicleHistoryPortoResponse;
}
